import React, { Component } from "react";
import {
  PageHeader, Row, Col, Card, Statistic, Spin, Empty, message,
  Table, Tag, Select, Space, Tooltip, Typography, Tabs,
} from "antd";
import { RiseOutlined, FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import {
  Form, FormItem, ButtonItem, SelectItem, RangePickerItem,
} from "../../../../Components/Items";
import { HeaderEmpresaCard } from "../../../../Components/PdfComponents/HeaderEmpresaCard";
import { ResponsiveBar } from "@nivo/bar";
import axios from "axios";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Text } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;

const fmt = (val) =>
  `$${(val ?? 0).toLocaleString("es-MX", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

const CARD_STYLE = { borderRadius: 10, overflow: "hidden" };

const COLORES_PDF = [
  "#4e79a7","#f28e2b","#e15759","#76b7b2",
  "#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ac",
];

const buildBarras = (datos, getVal, getLabel, fmtFn = String) => {
  const maxV = Math.max(...datos.map(getVal), 1);
  const W = 190, H = 11, G = 5;
  return {
    columns: [
      {
        width: W,
        canvas: datos.map((d, i) => ({
          type: "rect", x: 0, y: i * (H + G),
          w: Math.max(2, Math.round((getVal(d) / maxV) * W)),
          h: H, color: COLORES_PDF[i % COLORES_PDF.length], r: 2,
        })),
      },
      {
        width: "*",
        margin: [8, 0, 0, 0],
        stack: datos.map((d) => ({
          text: `${getLabel(d)}  ${fmtFn(getVal(d))}`,
          style: "textoTabla", color: "#444", margin: [0, 2, 0, G - 2],
        })),
      },
    ],
    margin: [0, 4, 0, 10],
  };
};

const PDF_STYLES = {
  header:               { fontSize: 9, bold: true },
  subheader:            { fontSize: 8, bold: true },
  tableExample:         { margin: [0, 5, 0, 5] },
  tableHeader:          { bold: true, fontSize: 12, color: "black", alignment: "center" },
  tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
  textoChico:           { fontSize: 8 },
  tituloTabla:          { fontSize: 7, bold: true, fillColor: "#cccccc", alignment: "center" },
  textoTabla:           { fontSize: 7 },
  totalChico:           { fontSize: 7, bold: true, fillColor: "#cccccc", alignment: "right" },
};

class ReportePipelineCRM extends Component {
  formRef = React.createRef();

  state = {
    loading:       false,
    datosPipeline: [],
    datosForecast: [],
    totalForecast: 0,
    embudos:       [],
    periodoStr:    "",
  };

  componentDidMount() {
    this.cargarEmbudos();
  }

  cargarEmbudos = async () => {
    const defaultValues = { periodo: [moment().startOf("year"), moment()] };
    try {
      const res = await axios.post(
        "embudos/selectEmbudosItem",
        { empresaId: this.props.empresaId, query: "" },
        { headers: this.props.headersToken },
      );
      if (res.data.success === 2) {
        this.setState({ embudos: res.data.embudos ?? [] }, () => {
          this.onFinish(defaultValues);
        });
      } else {
        this.onFinish(defaultValues);
      }
    } catch {
      this.onFinish(defaultValues);
    }
  };

  onFinish = (values) => {
    const { periodo, embudoId } = values;
    const periodoStr = periodo
      ? `${periodo[0].format("DD/MM/YYYY")} - ${periodo[1].format("DD/MM/YYYY")}`
      : "Histórico completo";
    this.setState({ periodoStr });
    this.cargarDatos({
      fechaInicio: periodo?.[0]?.toISOString() ?? null,
      fechaFin:    periodo?.[1]?.toISOString() ?? null,
      embudoId:    embudoId ?? null,
    });
  };

  cargarDatos = async ({ fechaInicio, fechaFin, embudoId } = {}) => {
    this.setState({ loading: true });
    try {
      const [resPipeline, resForecast] = await Promise.all([
        axios.post(
          "reportesCRM/pipelineReporte",
          { empresaId: this.props.empresaId, fechaInicio, fechaFin, embudoId },
          { headers: this.props.headersToken },
        ),
        axios.post(
          "reportesCRM/pronosticoCierreReporte",
          { empresaId: this.props.empresaId, fechaInicio, fechaFin, embudoId },
          { headers: this.props.headersToken },
        ),
      ]);
      if (resPipeline.data.success === 2)
        this.setState({ datosPipeline: resPipeline.data.datos });
      if (resForecast.data.success === 2)
        this.setState({ datosForecast: resForecast.data.datos, totalForecast: resForecast.data.totalForecast });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ loading: false });
    }
  };

  descargarExcel = () => {
    const { datosPipeline, datosForecast } = this.state;
    const wsPipeline = XLSX.utils.json_to_sheet(datosPipeline.map((d) => ({
      Etapa: d.nombre, Embudo: d.nombreEmbudo,
      "Leads Activos": d.cantidadLeads, "Valor Total ($)": d.totalValor,
    })));
    const wsForecast = XLSX.utils.json_to_sheet(datosForecast.map((d) => ({
      Etapa: d.nombre, "Prob. Éxito (%)": d.probabilidadExito,
      "Valor en Pipeline ($)": d.totalValor, "Valor Ponderado ($)": Math.round(d.totalPonderado),
    })));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsPipeline, "Pipeline");
    XLSX.utils.book_append_sheet(wb, wsForecast, "Forecast");
    XLSX.writeFile(wb, `Pipeline_Forecast_CRM_${new Date().toLocaleDateString("es-MX").replace(/\//g, "-")}.xlsx`);
  };

  descargarPdf = async () => {
    this.setState({ loading: true });
    try {
      const { datosPipeline, datosForecast, totalForecast } = this.state;

      const resEmpresa = await axios.post(
        "reportesCRM/datosEmpresaPdf",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      );
      const empresa = resEmpresa.data.success === 2 ? resEmpresa.data.empresa : {};

      const graficaPipeline = datosPipeline.length
        ? buildBarras(datosPipeline, (d) => d.cantidadLeads, (d) => d.nombre)
        : null;
      const graficaForecast = datosForecast.length
        ? buildBarras(datosForecast, (d) => Math.round(d.totalPonderado), (d) => d.nombre, fmt)
        : null;

      const terceraColumna = {
        border: [false, false, false, false],
        table: {
          widths: ["100%"],
          body: [
            [{ text: "Pipeline & Forecast CRM",         style: "tableHeader", alignment: "center" }],
            [{ text: `Forecast: ${fmt(totalForecast)}`, style: "textoChico",  alignment: "center" }],
            [{ text: "Fecha de Impresión:",              style: "subheader",   alignment: "center" }],
            [{ text: new Date().toLocaleDateString("es-MX"), style: "textoChico", alignment: "center" }],
          ],
        },
        layout: "noBorders",
      };

      const dd = {
        pageSize:    "LETTER",
        pageMargins: [20, 20, 20, 40],
        content: [
          {
            style: "tableExample",
            table: {
              widths: ["15%", "55%", "30%"],
              body: [[...HeaderEmpresaCard(empresa, false, false, terceraColumna)]],
            },
          },
          { text: "Pipeline & Forecast", style: "tableHeaderIzquierda", margin: [0, 6, 0, 8] },
          { text: "Pipeline Actual — Leads por Etapa", style: "subheader", margin: [0, 0, 0, 4] },
          ...(graficaPipeline ? [graficaPipeline] : []),
          {
            style: "tableExample",
            table: {
              headerRows: 1,
              widths: ["*", "*", "auto", "auto"],
              body: [
                [
                  { text: "Etapa",       style: "tituloTabla" },
                  { text: "Embudo",      style: "tituloTabla" },
                  { text: "Leads",       style: "tituloTabla" },
                  { text: "Valor Total", style: "tituloTabla" },
                ],
                ...datosPipeline.map((d) => [
                  { text: d.nombre,        style: "textoTabla" },
                  { text: d.nombreEmbudo,  style: "textoTabla" },
                  { text: d.cantidadLeads, style: "textoTabla", alignment: "right" },
                  { text: fmt(d.totalValor), style: "textoTabla", alignment: "right" },
                ]),
              ],
            },
            layout: {
              fillColor:  (i) => i % 2 === 0 && i !== 0 ? "#e8e8e8" : "#ffffff",
              hLineColor: () => "#adaaaa",
              vLineColor: () => "#adaaaa",
            },
          },
          { text: "Pronóstico Ponderado", style: "subheader", margin: [0, 10, 0, 4] },
          ...(graficaForecast ? [graficaForecast] : []),
          {
            style: "tableExample",
            table: {
              headerRows: 1,
              widths: ["*", "auto", "auto", "auto"],
              body: [
                [
                  { text: "Etapa",           style: "tituloTabla" },
                  { text: "Prob. Éxito",     style: "tituloTabla" },
                  { text: "Valor Pipeline",  style: "tituloTabla" },
                  { text: "Valor Ponderado", style: "tituloTabla" },
                ],
                ...datosForecast.map((d) => [
                  { text: d.nombre,                  style: "textoTabla" },
                  { text: `${d.probabilidadExito}%`, style: "textoTabla", alignment: "right" },
                  { text: fmt(d.totalValor),         style: "textoTabla", alignment: "right" },
                  { text: fmt(d.totalPonderado),     style: "textoTabla", alignment: "right", bold: true },
                ]),
                [
                  { text: "FORECAST TOTAL", style: "totalChico", colSpan: 3 }, {}, {},
                  { text: fmt(totalForecast), style: "totalChico" },
                ],
              ],
            },
            layout: {
              fillColor:  (i) => i % 2 === 0 && i !== 0 ? "#e8e8e8" : "#ffffff",
              hLineColor: () => "#adaaaa",
              vLineColor: () => "#adaaaa",
            },
          },
        ],
        images: { logo: empresa?.logo?.base64Completa ?? "" },
        styles: PDF_STYLES,
      };
      pdfMake.createPdf(dd).download(`Pipeline_Forecast_CRM_${new Date().toLocaleDateString("es-MX").replace(/\//g, "-")}.pdf`);
    } catch (e) {
      message.error("Hubo un error al generar el PDF.");
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { loading, datosPipeline, datosForecast, totalForecast, embudos } = this.state;
    const { history } = this.props;
    const hayDatos = datosPipeline.length > 0 || datosForecast.length > 0;

    const columnsPipeline = [
      { title: "Etapa",       dataIndex: "nombre",        render: (n, r) => <Tag color={r.color}>{n}</Tag> },
      { title: "Embudo",      dataIndex: "nombreEmbudo" },
      { title: "Leads",       dataIndex: "cantidadLeads",  align: "center" },
      { title: "Valor Total", dataIndex: "totalValor",     render: (v) => fmt(v), align: "right" },
    ];
    const columnsForecast = [
      { title: "Etapa",           dataIndex: "nombre",          render: (n, r) => <Tag color={r.color}>{n}</Tag> },
      { title: "Probabilidad",    dataIndex: "probabilidadExito", render: (v) => `${v}%`, align: "center" },
      { title: "Valor Pipeline",  dataIndex: "totalValor",       render: (v) => fmt(v), align: "right" },
      {
        title: "Valor Ponderado", dataIndex: "totalPonderado",
        render: (v) => <strong style={{ color: "#52c41a" }}>{fmt(v)}</strong>, align: "right",
      },
    ];

    return (
      <Form
        ref={this.formRef}
        onFinish={this.onFinish}
        initialValues={{ periodo: [moment().startOf("year"), moment()] }}
      >
        <PageHeader
          title={<span><RiseOutlined style={{ marginRight: 8, color: "#722ed1" }} />Pipeline & Forecast</span>}
          subTitle="Estado actual del pipeline y pronóstico ponderado de cierre"
          onBack={() => history.push("/panel/crmReportes")}
          style={{ border: "1px solid rgb(235,237,240)", backgroundColor: "white", marginBottom: 15 }}
          extra={
            <Space wrap>
              {hayDatos && (
                <Tooltip title="Descargar Excel">
                  <span>
                    <ButtonItem verde icon={<FileExcelOutlined />} onClick={this.descargarExcel} />
                  </span>
                </Tooltip>
              )}
              {hayDatos && (
                <Tooltip title="Descargar PDF">
                  <span>
                    <ButtonItem rojo icon={<FilePdfOutlined />} onClick={this.descargarPdf} loading={loading} />
                  </span>
                </Tooltip>
              )}
              <ButtonItem azul htmlType="submit">Consultar</ButtonItem>
            </Space>
          }
        />

        {/* Cintillo de filtros */}
        <div style={{
          backgroundColor: "white", padding: 20, paddingTop: 5,
          borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)", marginBottom: 10,
        }}>
          <Tabs
            defaultActiveKey="1"
            style={{ margin: 0 }}
            tabBarExtraContent={{ left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1> }}
          >
            <TabPane key="1" tab="Periodo">
              <FormItem name="periodo" noStyle>
                <RangePickerItem />
              </FormItem>
            </TabPane>
            <TabPane key="2" tab="Embudo">
              <FormItem name="embudoId" noStyle>
                <SelectItem
                  placeholder="Todos los embudos"
                  allowClear
                  style={{ width: "90%" }}
                >
                  {embudos.map((e) => (
                    <Option key={e._id} value={e._id}>{e.nombreEmbudo}</Option>
                  ))}
                </SelectItem>
              </FormItem>
            </TabPane>
          </Tabs>
        </div>

        <Spin spinning={loading}>
          <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
            <Col xs={24} sm={8} style={{ display: "flex" }}>
              <Card style={{ ...CARD_STYLE, flex: 1 }}>
                <Statistic
                  title="Forecast Total Ponderado"
                  value={totalForecast}
                  formatter={(v) => fmt(v)}
                  prefix={<RiseOutlined />}
                  valueStyle={{ color: "#52c41a" }}
                />
                <Text type="secondary" style={{ fontSize: 11 }}>
                  Valor ponderado por probabilidad de éxito de cada etapa
                </Text>
              </Card>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24} lg={12}>
              <Card title="Pipeline Actual — Leads por Etapa" style={CARD_STYLE}>
                {datosPipeline.length === 0 && !loading ? <Empty description="Sin leads activos" /> : (
                  <>
                    <div style={{ height: Math.max(240, datosPipeline.length * 48) }}>
                      <ResponsiveBar
                        data={datosPipeline.map((d) => ({ etapa: d.nombre, Leads: d.cantidadLeads }))}
                        keys={["Leads"]} indexBy="etapa" layout="horizontal"
                        margin={{ top: 10, right: 40, bottom: 20, left: 130 }} padding={0.3}
                        colors={(bar) => datosPipeline.find((d) => d.nombre === bar.indexValue)?.color ?? "#1890ff"}
                        colorBy="indexValue" borderRadius={4}
                        axisBottom={{ format: (v) => (Number.isInteger(v) ? v : "") }}
                        tooltip={({ value, indexValue }) => (
                          <div style={{ background: "white", padding: "4px 10px", border: "1px solid #f0f0f0", borderRadius: 4 }}>
                            <strong>{indexValue}</strong>: {value} leads
                          </div>
                        )}
                        theme={{ fontSize: 11 }}
                      />
                    </div>
                    <Table dataSource={datosPipeline} columns={columnsPipeline}
                      rowKey={(r) => r.etapaId?.toString() ?? r.nombre}
                      size="small" pagination={false} style={{ marginTop: 12 }} />
                  </>
                )}
              </Card>
            </Col>
            <Col xs={24} lg={12}>
              <Card title="Pronóstico Ponderado" style={CARD_STYLE}>
                {datosForecast.length === 0 && !loading ? <Empty description="Sin datos de pronóstico" /> : (
                  <>
                    <div style={{ height: Math.max(240, datosForecast.length * 48) }}>
                      <ResponsiveBar
                        data={datosForecast.map((d) => ({ etapa: d.nombre, Forecast: Math.round(d.totalPonderado) }))}
                        keys={["Forecast"]} indexBy="etapa" layout="horizontal"
                        margin={{ top: 10, right: 80, bottom: 20, left: 130 }} padding={0.3}
                        colors={["#52c41a"]} borderRadius={4}
                        axisBottom={{ format: (v) => `$${(v / 1000).toFixed(0)}k` }}
                        label={(d) => fmt(d.value)} labelSkipWidth={70}
                        tooltip={({ value, indexValue }) => (
                          <div style={{ background: "white", padding: "4px 10px", border: "1px solid #f0f0f0", borderRadius: 4 }}>
                            <strong>{indexValue}</strong>: {fmt(value)}
                          </div>
                        )}
                        theme={{ fontSize: 11 }}
                      />
                    </div>
                    <Table dataSource={datosForecast} columns={columnsForecast}
                      rowKey={(r) => r.etapaId?.toString() ?? r.nombre}
                      size="small" pagination={false} style={{ marginTop: 12 }} />
                  </>
                )}
              </Card>
            </Col>
          </Row>
        </Spin>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId:    state.empresa.id,
});

export default withRouter(connect(mapStateToProps)(ReportePipelineCRM));
